import largestRemainder from '../../../util/numbers/largestRemainder';

/**
 * Função que formata os dados dos resultados percentuais para 1 casa decimal
 * @param data dados do cruzamento simples
 * @param percentage porcentagem a qual a soma de todas as outrasa devem totalizar
 */
export function formatSimpleCrossData(data = []) {
  if (data === null) {
    return;
  }
  const perguntas_principais = data.perguntas_principais.map((atual) => {
    // Formatando os dados das alternativas
    const alternativasPrincipaisPercentuais = applyLargestRemainder(atual.alternativas);

    const newAlternativas = atual.alternativas.map((alternativa, index) => ({ ...alternativa, resultado_percentual: alternativasPrincipaisPercentuais[index] }));

    return {
      ...atual,
      alternativas: newAlternativas,
      perguntas_cruzadas: atual.perguntas_cruzadas.map((pergunta) => {
        // Formatando os dados das alternativas das perguntas principais
        const alternativasCruzadasPercentuais = applyLargestRemainder(pergunta.alternativas);

        // Formatando os dados das alternativas das perguntas cruzadas
        const alternativas = pergunta.alternativas.map((alternativa, index) => {
          const cruzamentosArray = [];
          const mapToArray = {};
          let i = 0;

          for (const key in alternativa.cruzamentos) {
            cruzamentosArray.push(alternativa.cruzamentos[key].resultado_percentual);
            mapToArray[key] = i++;
          }

          const totalPercentage = sumAndRound(cruzamentosArray);
          const formatedArray = largestRemainder(totalPercentage, cruzamentosArray, 0);
          i = 0;

          for (const key in alternativa.cruzamentos) {
            alternativa.cruzamentos[key] = {
              ...alternativa.cruzamentos[key],
              resultado_percentual: formatedArray[i++],
            };
          }

          return {
            ...alternativa,
            resultado_percentual: alternativasCruzadasPercentuais[index],
          };
        });

        return { ...pergunta, alternativas };
      }) };
  });

  return { ...data, perguntas_principais };
}

function applyLargestRemainder(alternativas) {
  const percentages = alternativas.map((alternativa) => alternativa.resultado_percentual);
  const total = sumAndRound(percentages);
  return largestRemainder(total, percentages, 0);
}

function sumAndRound(percentages) {
  return Math.round(
    percentages.reduce((reduced, next) => reduced + next),
  );
}
